import { setRedirecting } from '../redux/reducers/loading'
import { navigate } from 'gatsby'

export function navigateToPage(path: string) {
    return (dispatch: any) => {
        dispatch(setRedirecting(true))
        navigate(path)
        // Note: We can't set redirecting to false here because the component will unmount
        // The loading state will be reset when the new page loads
    }
}
